import type { RankingReport } from '@/queries/cpmRanking';
import { rankingReportStatus } from './rankingPresentation';

/** A missing measurement is different from a measured zero. */
export function rankingTrackedViews(report: Pick<RankingReport, 'tracked_views'>): string | null {
  const value = report.tracked_views;
  return value != null && /^\d+$/.test(value) ? BigInt(value).toString() : null;
}

function measuredViews(reports: RankingReport[]) {
  let total = 0n;
  let known = 0;
  for (const report of reports) {
    const views = rankingTrackedViews(report);
    if (views !== null) { total += BigInt(views); known += 1; }
  }
  return { views: reports.length > 0 && known === 0 ? null : total.toString(), missing: reports.length - known };
}

/** Only canonical owner clips have comparable fetched counters; legacy reports do not. */
export function summarizeRankingViews(reports: RankingReport[]) {
  const clips = reports.filter(report => report.submission_id);
  const pending = clips.filter(report => rankingReportStatus(report) === 'pending');
  const rejected = clips.filter(report => rankingReportStatus(report) === 'rejected');
  const tracked = measuredViews(clips);
  const waiting = measuredViews(pending);
  return {
    trackedViews: tracked.views,
    missingClips: tracked.missing,
    pendingViews: waiting.views,
    pendingClips: pending.length,
    pendingMissingClips: waiting.missing,
    rejectedViews: measuredViews(rejected).views,
    rejectedClips: rejected.length,
  };
}
